export default "__VITE_ASSET__f405e0ef__"